import classNames from 'classnames'
import React from 'react'
import mailIcon from '../assets/icons/social/mail.svg'
import phoneIcon from '../assets/icons/social/phone.svg'
import { useTranslations } from '../hooks/useTranslations'
import { isNullOrWhiteSpace, stripWhiteSpace } from '../utilities/string'
import { IconButton } from './IconButton'

export interface ContactButtonsProps {
  additionalClassName?: string
  email?: string
  name: string
  phone?: string
}

export const ContactButtons = ({
  additionalClassName = '',
  email,
  name,
  phone,
}: ContactButtonsProps) => {
  const translations = useTranslations()

  return (
    <div className={classNames('flex flex-wrap', additionalClassName)}>
      {!isNullOrWhiteSpace(email) && (
        <a
          className="mt-10 mr-15 group focus:outline-none"
          href={`mailto:${email.trim()}`}
          aria-label={translations.contactViaEmail?.replace('#', name) ?? ''}
        >
          <IconButton svg={mailIcon} transparent>
            {translations.sendEmailButton ?? 'Send email'}
          </IconButton>
        </a>
      )}

      {!isNullOrWhiteSpace(phone) && (
        <a
          className="mt-10 group focus:outline-none"
          href={`tel:${stripWhiteSpace(phone)}`}
          aria-label={translations.contactCall?.replace('#', name)}
        >
          <IconButton svg={phoneIcon} transparent>
            {translations.callButton ?? 'Call'}
          </IconButton>
        </a>
      )}
    </div>
  )
}
